import * as React from "react";
import { Component } from "react";
import { Field, Form, getFormValues, reduxForm } from "redux-form";
import styles from "../../../styles/forms/superadmin/add_product_subgroup_wizard/AddProductSubgroupForm.scss";
import Button from "../../../components/Button";
import Select from "../../../components/Select";
import MultiSelect from "../../../components/MultiSelect";
import Input from "../../../components/Input";
import { __, mapStateToProps, setTableParams, transformToListPairs, getLocalized } from "../../../core/utils";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import ButtonGroup from "../../../components/ButtonGroup";
import { subscribe } from "react-contextual";
import Localization from "../../../helpers/Localization";
import * as _ from "lodash";

@withRouter
@reduxForm({ form: "superadmin.add_product_subgroup_wizard.add_product_subgroup" })
@subscribe(Localization, "localization")
@mapStateToProps(state => ({
    values: getFormValues("superadmin.add_product_subgroup_wizard.add_product_subgroup")(state),
    auth: state.auth,
    application_language_id: state.auth.language_id
}))
class AddProductSubgroupForm extends Component {
    @autobind
    _handleSubmit(edit) {
        this.props.change('edit', edit);

        setTimeout(() => this.props.submit(), 10);
    }

    render() {
        const application_languages = _.transform(_.filter(this.props.localization.languages, language => language.application_language == true), (languages, language) => {
            languages[language.id] = language.id == this.props.auth.language_id;

            return languages;
        }, {});

        const specification_subgroups = _.map(this.props.localization.specification_subgroups, item => ({
            value: item.id,
            label: getLocalized(item.name, this.props.application_language_id),
        }));

        const product_attribute_template_fields = _.sortBy(_.map(this.props.localization.product_attribute_fields, product_subgroup => {
            const product_attribute_template_group = _.get(this.props.localization.product_attribute_groups, product_subgroup.product_attribute_template_group_id, {});

            return {
                label: getLocalized(product_subgroup.label),
                value: product_subgroup.id,
                groupPriority: product_attribute_template_group.priority,
                group: getLocalized(product_attribute_template_group.name, this.props.application_language_id),
            };
        }), 'groupPriority');

        return (
            <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
                <div className={styles.form}>
                    <Field name="name" localized={application_languages} component={Input} label="Name" />
                    <Field name="product_group_id" component={Select} searchable options={transformToListPairs(this.props.localization.product_groups)} label="Product Group" />
                    <Field name="priority" numeric component={Input} label="Priority" />
                    <Field name="specification_subgroups" component={MultiSelect} searchable options={specification_subgroups} label="Linked Specification Subgroups" />
                    <Field name="product_attribute_template_field_ids" component={MultiSelect} searchable noSort options={product_attribute_template_fields} label="Assigned Product Attribute Fields" />
                </div>
                <div className={styles.footer}>
                    <Button lightGray medium left middleText={__('button.cancel')} onClick={() => setTableParams('superadmin_product_subgroups', {
                        add_product_subgroup_wizard: undefined
                    })} />
                    <ButtonGroup>
                        <Button lightBlue medium middleText={__('button.create')} spinning={this.props.submitting} onClick={() => this._handleSubmit(false)} />
                        <Button lightBlue medium middleText={__('button.create-edit')} spinning={this.props.submitting} onClick={() => this._handleSubmit(true)} />
                    </ButtonGroup>
                </div>
            </Form>
        );
    }
}

export default AddProductSubgroupForm;
